import React, { useEffect, useState, useContext } from 'react';
import {   CircularProgress, Container, Typography, Accordion,   Box, AccordionSummary, Checkbox, AccordionDetails,Tooltip,Stack, Button, Badge } from '@mui/material';
import { ExpandMore, Visibility,PictureAsPdf, Edit, Delete } from '@mui/icons-material';
import documentoApi from '../../api/documentoApi';
import filesApi from '../../api/filesApi';
import { useNavigate } from 'react-router-dom';
import ProtectedAction from '../../components/ProtectedAction';
import { AuthContext } from '../../auth/AuthContext';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import { formatDate } from '../../utils/dateFormatter';

export default function DocumentiListPageMobile() {
  const { user } = useContext(AuthContext);
  const [documenti, setDocumenti] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
  const [mergeError, setMergeError] = useState(null);
  const [merging, setMerging] = useState(false);
  const navigate = useNavigate();
  const pageSize = 10;

  useEffect(() => fetchDocumenti(0), []);

  const fetchDocumenti = (page) => {
    const params = { page, size: pageSize };
    let promise;

    if (user.role === 'CONTRIBUENTE') {
      promise = documentoApi.listbycontribuente(user.contribuenteId, params);
    } else if (user.role === 'STUDIO') {
      promise = documentoApi.listbystudio(user.studioId, params);
    } else {
      promise = documentoApi.list(params);
    }

    promise
      .then(r => {
        setDocumenti(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
      })
      .catch(console.error).finally(setLoading(false));
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const closeDeleteDialog = () => {
    setSelectedId(null);
    setOpenDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await documentoApi.delete(selectedId);
      fetchDocumenti(page);
    } catch (err) {
      console.error(err);
    } finally {
      closeDeleteDialog();
    }
  };

  const openPdf = async (filename) => {
    try {
      const res = await filesApi.getfile(filename, user.contribuenteId);
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      console.error(err);
    }
  };
      // --- SELEZIONE E MERGE ---
      const toggleSelection = (id) => {
        setSelectedDocumentIds(prev =>
          prev.includes(id)
            ? prev.filter(x => x !== id)
            : [...prev, id]
        );
      };
      const canMerge = () => {
        if (selectedDocumentIds.length < 2) return false;

        const selectedDocs = documenti.filter(d =>
          selectedDocumentIds.includes(d.id)
        );

        const first = selectedDocs[0];
        return selectedDocs.every(d =>
          d.contribuente.id === first.contribuente.id &&
          d.tipo === first.tipo &&
          d.numeroDocumento === first.numeroDocumento
        );
      };

        const handleMerge = async () => {
          setMergeError(null);
          setMerging(true);
          try {
            await documentoApi.mergeDocumenti(selectedDocumentIds);
            setSelectedDocumentIds([]);
            fetchDocumenti(page);
          } catch (e) {
            setMergeError(e.response?.data?.error || e.response?.data || 'Errore durante il merge dei documenti');
            if(
            e.response?.data?.error!="I documenti non appartengono allo stesso contribuente" &&
            e.response?.data?.error!="Tipologia dei documenti non compatibile" &&
            e.response?.data?.error!="I documento non hanno lo stesso identificativo di atto/pratica" &&
            e.response?.data?.error!="Servono almeno due documenti"){
              setSelectedDocumentIds([]);
              fetchDocumenti(page);
            }
          } finally {
            setMerging(false);
          }
        };
        // --- /SELEZIONE E MERGE ---
  return (
    <Container sx={{ mt: 2 }}>

      <Typography variant="h5" sx={{ mb: 2 }}>Documenti</Typography>
                  {/* Bottone merge */}
                  <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <ProtectedAction user={user} contractState={user.statoContratto}>
                      <Button
                        variant="contained"
                        color="warning"
                        disabled={!canMerge() || merging}
                        onClick={handleMerge}
                      >
                        Unisci documenti selezionati
                      </Button>
                    </ProtectedAction>
                  </Stack>

                  {mergeError && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                      {typeof mergeError==='string' ? mergeError : JSON.stringify(mergeError)}
                    </Alert>
                  )}
                        {loading && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 0, left: 0, right: 0, bottom: 0,
                              bgcolor: 'rgba(255,255,255,0.7)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              zIndex: 10,
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        )}
      <Stack spacing={2}>
        {documenti.map(d => (
          <Accordion key={d.id}>
            <AccordionSummary expandIcon={<ExpandMore />}>
             <Tooltip title="seleziona per merge">
                      <Checkbox
                        checked={selectedDocumentIds.includes(d.id)}
                        onChange={() => toggleSelection(d.id)}
                      />
             </Tooltip>
              <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%', justifyContent: 'space-between' }}>
                {d.numeroDocumento}
                <Typography>{d.tipo} {d.numeroDocumento} {d.descrizione}</Typography>
                {d.rateSaltate > 0 && <Badge color="error" badgeContent={d.rateSaltate}><span /></Badge>}
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">{d.contribuente?.nome} {d.contribuente?.cognome}</Typography>
              <Typography variant="body2">Data creazione: {d.dataCreazione}</Typography>
              <Typography variant="body2">Decaduto: {d.decaduta?'SI':'NO'}</Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                <Button size="small" onClick={() => navigate(`/documenti/${d.id}`)} startIcon={<Visibility />}>Visualizza</Button>
                <ProtectedAction user={user} contractState={user.statoContratto}>
                <Button size="small" onClick={() => navigate(`/documenti/edit/${d.id}`)} startIcon={<Edit />}>Modifica</Button>
                <Button size="small" color="error" onClick={() => openDeleteDialog(d.id)} startIcon={<Delete />}>Elimina</Button>

                </ProtectedAction>
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>

      {/* Paginazione semplice */}
      <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchDocumenti(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo documento?"
      />
    </Container>
  );
}